import * as React from "react";
import type { SVGProps } from "react";
const SvgShieldPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="m4.8 5.788-.447-.895a1 1 0 0 0-.553.895zm7.2 15.6-.534.845a1 1 0 0 0 1.068 0zm7.2-15.6h1a1 1 0 0 0-.553-.895zm-8.81-2.795-.447-.895zm3.22 0 .447-.895zm1.09 8.895a1 1 0 1 0 0-2v2m-5.4-2a1 1 0 0 0 0 2v-2m1.7 3.7a1 1 0 1 0 2 0h-2m2-5.4a1 1 0 1 0-2 0h2m-2.61-5.195-.447-.895-5.59 2.795.447.895.447.894 5.59-2.795zM4.8 5.788h-1v8.028h2V5.788zm0 8.028h-1c0 1.479.863 2.881 2.144 4.199 1.301 1.338 3.178 2.738 5.522 4.218l.534-.846.534-.845c-2.293-1.448-4.017-2.75-5.156-3.921-1.16-1.193-1.578-2.113-1.578-2.805zm7.2 7.571.534.846c2.305-1.456 4.194-2.708 5.5-3.971 1.334-1.29 2.166-2.694 2.166-4.446h-2c0 1.02-.45 1.937-1.556 3.008-1.134 1.097-2.845 2.245-5.178 3.718zm7.2-7.571h1V5.788h-2v8.028zm0-8.028.447-.895-5.59-2.795-.447.895-.447.894 5.59 2.795zm-8.81-2.795.447.894a2.6 2.6 0 0 1 2.326 0l.447-.894.447-.895a4.6 4.6 0 0 0-4.114 0zm4.31 7.895v-1H12v2h2.7zm-2.7 0v-1H9.3v2H12zm0 2.7h1v-2.7h-2v2.7zm0-2.7h1v-2.7h-2v2.7z"
    />
  </svg>
);
export default SvgShieldPlus;
